// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","animloader":"Loader_animloader__v+PFL"};